module.exports = __webpack_public_path__ + "static/img/no-binding-1.ab79a5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-binding-1.jpg
// module id = 7N4t
// module chunks = 2